<template>
  <div id="holacon-session-container" v-if="currentSession" :style="'background-image: url(https://img.imageus.dev/' + currentSession.backgrounBanner + '?width=1920&height=1200'">
    <div v-if="!getPublisher" class="banner top" :style="'background-image: url(' + $imageus + currentSession.topBanner + '?width=1000&height=100'"></div>

    <WatcherCount :key="'watcher-count-' + currentSession.id" :watcherCount="currentSession.watcherCount" v-if="currentSession.showWatcherCount" v-show="false" />

    <template v-if="getPublisher && currentSession.sessionType != 2">
      <transition name="el-fade-in" mode="out-in">
        <Room roomType="session" :key="currentSession.id" :roomId="currentSession.id" v-if="getParticipant != null"></Room>
      </transition>
    </template>
    <transition name="el-fade-in" mode="out-in" v-else-if="currentSession.isLive == false && !getPublisher">
      <template>
        <div class="countdown" style="display: flex; flex: 1; align-items: center; height: calc(100vh)">
          <flip-countdown :labels="{ days: $t('countdown.days'), hours: $t('countdown.hours'), minutes: $t('countdown.minutes'), seconds: $t('countdown.seconds') }" :deadline="currentSession.startDate.replace('T', ' ').replace('Z', '')"></flip-countdown>
        </div>
      </template>
    </transition>

    <template v-else>
      <transition name="el-fade-in" mode="out-in">
        <VideoRoom v-if="currentSession.sessionType == 1 || currentSession.sessionType == 0" :key="'video-room' + currentSession.isLive" />
        <VimeoRoom v-if="currentSession.sessionType == 2" :key="'vimeo-room'" />
      </transition>
    </template>

    <div v-if="!getPublisher" class="banner bottom" :style="'background-image: url(' + $imageus + currentSession.bottomBanner + '?width=1000&height=100'"></div>
  </div>
</template>

<script>
import VimeoRoom from "../media/VimeoRoom";
import Room from "../media/Room";
import axios from "axios";
import FlipCountdown from "../../modules/FlipCountdown";
import WatcherCount from "../WatcherCount";
import VideoRoom from "../media/VideoRoom";

export default {
  components: {
    Room,
    FlipCountdown,
    WatcherCount,
    VimeoRoom,
    VideoRoom
  },
  async created() {
    await this.$store.dispatch("getSessions", { id: this.currentEvent.id, route: false });
    await this.$store.dispatch("getSession", { id: this.$route.params.session_id, route: false });
    this.$socket.emit("subscribe", { channel: "presence-session-" + this.currentApplication.id + "-" + this.currentEvent.id + "-" + this.currentSession.id, token: "" });
  },

  async mounted() {},
  beforeDestroy() {
    if(this.currentSession != null)
    {
      this.$socket.emit("unsubscribe", "presence-session-" + this.currentApplication.id + "-" + this.currentEvent.id + "-" + this.currentSession.id);
    }

    this.$store.commit("setCurrentSession", null);
  },

  computed: {
    currentApplication() {
      return this.$store.getters.getApplication;
    },
    currentEvent() {
      return this.$store.getters.getEvent;
    },

    currentSession() {
      return this.$store.getters.getCurrentSession;
    },

    getParticipant() {
      return this.$store.state.participant.item;
    },

    getPublisher() {
      if (this.currentSession != null) {
        return this.currentSession.publishers.find(x => x.participantID == this.getParticipant.id && x.isActive == true);
      }
    }
  },
  watch: {}
};
</script>




// WEBPACK FOOTER //
// src/components/event/Session.vue